export class AppVersion {
    AppName?: string;
    AppVersion?: string;
    CIMSVersion?: string;
    G3MSVersion?: string;
    BuildDate?: string;
    EnableBulkUpload?: boolean;
}
